class SyncModel {

    horario_inicio: string | null;
    horario_fim: string | null;
    qtd_itens_processados: number | null;

    constructor() {
        this.horario_inicio = null;
        this.horario_fim = null;
        this.qtd_itens_processados = null;
    }

}

export default SyncModel;
